import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, FormArray } from '@angular/forms';
import { environment } from 'src/environments/environment';
import { AuthservicesService } from 'src/app/services/authservices.service';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-create-bulletine',
  templateUrl: './create-bulletine.component.html',
  styleUrls: ['./create-bulletine.component.css']
})
export class CreateBulletineComponent implements OnInit {
  form: FormGroup;
  expirationdays
  submitted = false
  loading = false
  errorMessage
  fileName
  file
  error
  errorShow = false
  bulltineID
  currentUser = JSON.parse(localStorage.getItem('ministry_currentUser'))
  objArr
  constructor(private fb: FormBuilder, private authService: AuthservicesService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.expirationdays = environment.expirationdays
    this.errorMessage = environment.errorMessage

    this.route.params
      .subscribe(
        (params) => {
          this.bulltineID = params['id'];
        }
      );

    this.getBulltin()
    this.form = this.fb.group({
      file: [''],
      link: [''],
      name: ['', Validators.required],
      expirationDay: ['', Validators.required]
    })

  }
  get f() {
    return this.form.controls;
  }

  uploadBanner(event) {
    this.fileName = "";

    if (event.target.files.length == 0) {
      return
    }

    let docType
    let docFile
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.fileName = file.name

      let split = this.fileName.split('.')

      split.forEach(e => {
        if (e == 'pdf') {
          docType = e
          docFile = 'doc'
        }
        else {
          docType = 'image'
          docFile = 'image'
        }
      });


      const formData = new FormData();
      formData.append(docFile, file, file.name);
      formData.append('imageType', docType);
      this.authService
        .uploadFileUpload(formData)
        .subscribe(
          data => {
            this.file = '';
            this.file = environment.basePath + data['data'].url;

            this.form.get('file').setValue(this.file)
          },
          error => {
            this.authService.successMessage(error.error.message, 'error')

          }
        );
    } else {
      this.authService.successMessage('Error', 'error')

    }
  }
  onSubmit() {
    this.submitted = true;

    if (this.form.get('link').value == "" && this.form.get('file').value == '') {

      this.error = "Either add PDF link or upload PDF file"
      this.errorShow = true
      this.authService.scrollToError();
      return;

    }
    this.errorShow = false

    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    this.authService.addBulltin(this.form.value).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success').then((res) => {
        if (res.value) {
          this.router.navigate(['/bulletins'])

        }
      })

    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }

  getBulltin() {
    this.authService.getBulltin(this.currentUser.id).subscribe((res: any) => {
      this.objArr = res.data
      this.objArr.forEach(e => {


        if (e._id == this.bulltineID) {
          this.form.patchValue({
            file: e.file,
            link: e.isShown,
            name: e.name,
            expirationDay: e.expirationDay

          })
          this.file = e.file
          this.fileName = e.file

          return
        }
      });


    },
      error => {
        console.log(error)
      })
  }

  formRequest() {
    if (this.bulltineID != undefined) {

      this.onUpdate()
    }
    else {
      this.onSubmit()

    }
  }

  onUpdate() {
    this.submitted = true;

    if (this.form.get('link').value == "" && this.form.get('file').value == '') {

      this.error = "Either add PDF link or upload PDF file"
      this.errorShow = true
      this.authService.scrollToError();
      return;

    }
    this.errorShow = false

    if (this.form.invalid) {
      this.authService.scrollToError();
      return;
    }

    this.authService.editBulltin(this.bulltineID, this.form.value).subscribe((res: any) => {
      this.authService.successMessage(res.message, 'success').then((res) => {
        if (res.value) {
          this.router.navigate(['/bulletins'])

        }
      })

    },
      error => {
        this.authService.successMessage(error.error.message, 'error')
      })
  }

}
